import React from "react";
import {
  richTextWrapper,
  sectionWrapper,
  tableRow,
  fullWidthStyle
} from "./style.mod.scss";
import RichText from "components/rich-text";
import useResponsiveConfig from "hooks/useResponsiveConfig";
import parsePadding from "helpers/parse-padding";
import Container from "react-bootstrap/Container";

const RichTextSection = ({ data }) => {
  if (!data || !data.blockContent) return <></>;

  const {
    blockContent, mobilePadding, tabletPadding, desktopPadding, alignment,
    tablesInRow, highlightColor, fullWidthContainer, bgColor
  } = data;

  const config = useResponsiveConfig({
    mobile: { styles: parsePadding(mobilePadding) },
    tablet: { styles: parsePadding(tabletPadding) },
    desktop: { styles: parsePadding(desktopPadding) }
  });

  const id = data?.sectionContent?.sectionID;

  return (
    <div className={`${sectionWrapper} ${fullWidthContainer && fullWidthStyle}`} style={{
      ...config.styles,
      backgroundColor: bgColor && bgColor?.hex,
      textAlign: alignment
    }} id={id}>
      <Container>
        <RichText
          className={tablesInRow ? `${tableRow} ${richTextWrapper} ` : richTextWrapper}
          blocks={blockContent}
          highlightColor={highlightColor}
          fullWidthContainer={fullWidthContainer}
        />
      </Container>
    </div>

  );
};

export default RichTextSection;
